module.exports = __webpack_public_path__ + "img/2-lrn-spt-logo-252.07429b0f.svg";